import { Component, inject } from '@angular/core';
import { MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { RouterModule } from '@angular/router';
import { ColorModesEnum } from '@core/enums/color-mode.enum';

@Component({
  selector: 'app-dev-tool-sheet',
  imports: [MatIconModule, MatListModule, MatButtonModule, RouterModule],
  templateUrl: './dev-tool-sheet.component.html',
  styleUrl: './dev-tool-sheet.component.scss',
})
export class DevToolSheetComponent {
  private _bottomSheetRef = inject<MatBottomSheetRef<DevToolSheetComponent>>(MatBottomSheetRef);

  ColorModesEnum = ColorModesEnum;

  closeDevTool() {
    this._bottomSheetRef.dismiss();
  }
}
